export function deleteMembership (state, membershipId) {
	const membershipIndex = state.memberships.findIndex(membership => membership.id === membershipId);

	if (membershipIndex < 0) return;

	state.memberships.splice(membershipIndex, 1);
}
